import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/auth/login";
import Portfolio from "./pages/portfolio/interface/portfolio";
import ModalPortfolio from "./pages/modalPortfolio/interface/mPortfolio";
import Multibaggers from "./pages/multibaggers/interface/multibagger";
import { useSelector } from "react-redux";
import Dashboard2 from "./pages/dashboard/Dashboard2";
import Etf from "./pages/etf/Etf";
import MutualFunds from "./pages/mutualFunds/MutualFunds";
import Ipo from "./pages/ipo/Ipo";
import LiveCalls from "./pages/liveCalls/LiveCalls";
import MyAccounts from "./pages/myAccounts/MyAccounts";
import FundAllocation from "./pages/fundAllocation/FundAllocation";
import EtfModel from "./pages/etf/EtfModel";
import MultibaggerModel from "./pages/multibaggers/interface/multibaggerModel";
import PortofolioFundAllocation from "./pages/portfolio/interface/PortofolioFundAllocation";
import EtfFundAllocation from "./pages/etf/EtfFundAllocation";
import RiskProfile2 from "./pages/riskProfile/RiskProfile";
import Pricing from "./pages/pricing/Pricing";
import Checkout from "./pages/pricing/Checkout";
import Kyc from "./pages/kyc/Kyc";
import { getAuthenticatedRedirectPath } from "./utils/authRedirect";

const hasProfileValue = (value) => String(value ?? "").trim().length > 0;
const isLoginProfileComplete = (userDetail) => (
  hasProfileValue(userDetail?.firstName) &&
  hasProfileValue(userDetail?.state) &&
  hasProfileValue(userDetail?.email) &&
  hasProfileValue(userDetail?.mobile)
);

// Route guard component
const ProtectedRoute = ({ isAuthenticated, shouldCompleteProfile, userDetail, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (shouldCompleteProfile) {
    return <Navigate to="/login" replace />;
  }

  const redirectPath = getAuthenticatedRedirectPath(userDetail);

  if (redirectPath !== "/dashboard") {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

const OnboardingRoute = ({ isAuthenticated, shouldCompleteProfile, userDetail, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (shouldCompleteProfile) {
    return <Navigate to="/login" replace />;
  }

  const redirectPath = getAuthenticatedRedirectPath(userDetail);
  const isLead = String(userDetail?.userStatus ?? "").trim().toLowerCase() === "lead";

  if (redirectPath === "/risk-profile" || isLead) {
    return children;
  }

  return <Navigate to={redirectPath} replace />;
};

const PricingRoute = ({ isAuthenticated, shouldCompleteProfile, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (shouldCompleteProfile) {
    return <Navigate to="/login" replace />;
  }

  return children;
};


const GuestRoutes = () => {
  const authState = useSelector(state => state.auth.authState)
  const userDetail = useSelector(state => state.auth.userDetail)
  const shouldCompleteProfile = authState && userDetail && !isLoginProfileComplete(userDetail);
  const authenticatedRedirectPath = getAuthenticatedRedirectPath(userDetail);
  // useEffect(() => {
  //   if (authState) {
  //     navigate("/login")
  //   }
  // }, [])
  return (
    <Routes>
      <Route
        path="/login"
        element={
          authState && !shouldCompleteProfile ? <Navigate to={authenticatedRedirectPath} replace /> : <Login />
        }
      />
      {/* <Route
        path="/home"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <Home />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/"
        element={
          // <Home />
          authState && !shouldCompleteProfile ? <Navigate to={authenticatedRedirectPath} replace /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/portfolio"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <Portfolio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/modalportfolio"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <ModalPortfolio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            {/* <Dashboard /> */}
            <Dashboard2/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/risk-profile"
        element={
          <OnboardingRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            {/* <Dashboard /> */}
            <RiskProfile2/>
          </OnboardingRoute>
        }
      />
      <Route
        path="/pricing"
        element={
          <PricingRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            {/* <Dashboard /> */}
            <Pricing/>
          </PricingRoute>
        }
      />
      <Route
        path="/checkout"
        element={
          <PricingRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            {/* <Dashboard /> */}
            <Checkout/>
          </PricingRoute>
        }
      />
      <Route
        path="/kyc"
        element={
          <PricingRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            {/* <Dashboard /> */}
            <Kyc/>
          </PricingRoute>
        }
      />
      <Route
        path="/multibagger"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <Multibaggers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/etf"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <Etf />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mutual-funds"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <MutualFunds />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ipo"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <Ipo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/short-term-investments"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <LiveCalls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/option-hedging"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <LiveCalls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/options"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <LiveCalls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/opportunities"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <LiveCalls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/live-calls"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <LiveCalls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/etf-lock"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <EtfModel/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/multibaggers-lock"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <MultibaggerModel/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-account"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <MyAccounts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fund-allocation"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <FundAllocation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-fund-allocation"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <FundAllocation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/portfolio-allocation"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <PortofolioFundAllocation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/etf-allocation"
        element={
          <ProtectedRoute isAuthenticated={authState} shouldCompleteProfile={shouldCompleteProfile} userDetail={userDetail}>
            <EtfFundAllocation />
          </ProtectedRoute>
        }
      />
      {/* Catch-all route for unmatched paths */}
      <Route
        path="*"
        element={
          authState && !shouldCompleteProfile ? <Navigate to={authenticatedRedirectPath} replace /> : <Navigate to="/login" replace />
        }
      />
    </Routes>
  );
};

export default GuestRoutes;


// import { Navigate, Route, Routes } from "react-router-dom";
// import { useSelector } from "react-redux";

// import Login from "./pages/auth/login";
// import Home from "./pages/home/home";
// import Portfolio from "./pages/portfolio/index";
// import Dashboard from "./pages/dashboard/index";
// import Multibaggers from "./pages/multibaggers/index";

// // Enhanced ProtectedRoute component
// const ProtectedRoute = ({ isAuthenticated, userDetail, children, path }) => {
//   // const shouldCheckUserDetail = path !== "/login" && path !== "/dashboard";

//   const hasRequiredUserDetails =
//     userDetail?.portfolioAmt && userDetail?.multibaggerAllocation;

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if ( !hasRequiredUserDetails) {
//     return <Navigate to="/dashboard"  />;
//   }

//   return children;
// };

// const GuestRoutes = () => {
//   const authState = useSelector((state) => state.auth.authState);
//   const userDetail = useSelector((state) => state.auth.userDetail); // Ensure this exists in your Redux store

//   return (
//     <Routes>
//       <Route
//         path="/login"
//         element={
//           authState ? <Navigate to="/dashboard" replace /> : <Login />
//         }
//       />
//       <Route
//         path="/portfolio"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/portfolio"
//           >
//             {/* You can change Home to Portfolio when needed */}
//             <Home />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/dashboard"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/dashboard"
//           >
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/multibagger"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/multibagger"
//           >
//             <Multibaggers />
//           </ProtectedRoute>
//         }
//       />
//       {/* Catch-all route */}
//       <Route
//         path="*"
//         element={
//           authState ? (
//             <Navigate to="/dashboard" replace />
//           ) : (
//             <Navigate to="/login" replace />
//           )
//         }
//       />
//     </Routes>
//   );
// };

// export default GuestRoutes;
